// Обращения сотрудников: /api/v2/feedback (erp-backend, модуль src/feedback). [Claude, 04.11.2026]
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function createFeedback(payload) {
  const { data } = await api.post('feedback', payload)
  return data
}

export async function fetchFeedback(params = {}) {
  const { data } = await api.get('feedback', { params })
  return data
}

export async function setFeedbackStatus(id, status, resolution) {
  const { data } = await api.post('feedback/' + id + '/status', { status, resolution: resolution || null })
  return data
}
